<template>
    <div class="_404">
		<h1>404</h1>
		<p>——组件错误——</p>
	</div>
</template>

<style>
._404 {
	padding:20px 0 0;
	vertical-align:middle;
	text-align:center;
}
._404 h1 {
	font-size:80px;
}
._404 p {
	font-size:20px;
}
</style>

<script>
export default {
  name: 'incErr'
}
</script>




// WEBPACK FOOTER //
// src/components/inc/component/_404.vue